<script setup lang="ts">
    import type { IWidgetProps } from '~/composables/widgets';

    const props = defineProps<IWidgetProps<HeroBannerData>>();

    const { font_color = ref(undefined), overlay: overlayOpacity = ref('opacity_0') } = toRefs(
        reactive(props.data.style || ({} as Exclude<HeroBannerData['style'], undefined>)),
    );

    const theme = props.data.style.theme || 'light';

    const fontStyles = computed(() => {
        if (theme !== 'custom') return;
        return {
            color: font_color.value || woomColor('white'),
        };
    });
</script>
<template>
    <section class="relative mb-8 h-60 md:mb-10 md:h-80 lg:h-96">
        <atm-asset
            :data="data.imageMobile || data.image"
            :image-loading="componentIndex === 0 ? 'eager' : 'lazy'"
            sizes="300 xs:640 sm:768"
            preset="2to3"
            role="presentation"
            cover
            class="absolute h-full w-full md:hidden" />
        <atm-asset
            :data="data.image"
            :image-loading="componentIndex === 0 ? 'eager' : 'lazy'"
            role="presentation"
            sizes="1px md:1264px lg:1920px"
            cover
            class="absolute hidden h-full w-full md:block" />
        <div :class="['absolute inset-0 bg-black', overlayOpacity.replace('_', '-')]"></div>
        <atm-container
            v-if="data.title"
            class="flex h-full flex-col justify-end pb-4 md:pb-8">
            <lazy-atm-heading
                :class="['relative z-30 line-clamp-5', { 'text-woom-black': theme === 'dark', 'text-woom-white': theme === 'light' }]"
                :style="fontStyles">
                <renderer-html :content="woomTextFormat(data.title, true)" />
            </lazy-atm-heading>
        </atm-container>
    </section>
</template>
